import React, { Fragment } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Grid, FormControl, Radio, RadioGroup, Typography, FormGroup, FormLabel } from "@material-ui/core";
import CustomCheckbox from "../CustomCheckbox";
import translate from '../../other/translate.json';

export default function FilterArchitecture(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru';
  const [value, setValue] = React.useState(null);

  return (
    <React.Fragment>
      <FormControl component="fieldset">
        <FormLabel component="legend" focused={false} className={classes.header}>{translate.Words[`Architecture${language}`]}:</FormLabel>

        <FormGroup>
          <FormControlLabel
            control={<CustomCheckbox checked={props.platform === '1'} onChange={() => { props.platform === '1' ? props._platform('0') : props._platform('1') }} />}
            label={translate.Words[`Platform12MCA${language}`]}
            className={classes.FClabel}
          />

          <FormControlLabel
            control={<CustomCheckbox checked={props.msa === '1'} onChange={() => { props.msa === '1' ? props._msa('0') : props._msa('1') }} />}
            label={translate.Words[`Platform2MCA${language}`]}
            className={classes.FClabel}
          />

          <FormControlLabel
            control={<CustomCheckbox checked={props.microservice === '1'} onChange={() => { props.microservice === '1' ? props._microservice('0') : props._microservice('1') }} />}
            label={translate.Words[`Platform2МСАDBI${language}`]}
            className={classes.FClabel}
          />

          {/* <FormControlLabel
            control={<Checkbox checked={antoine} onChange={handleChange} name="antoine" />}
            label="Antoine Llorca"
          /> */}
        </FormGroup>
      </FormControl>
    </React.Fragment>
  )
}

const useStyles = makeStyles(theme => ({
  header: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  FClabel: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  }
}))